<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-input
          size="medium"
          v-model="searchForm.name"
          placeholder="请输入文章标题"
          @keyup.enter.native="getTableList"
        ></el-input>
        <el-select
          size="medium"
          v-model="searchForm.lan"
          placeholder="请选择发布场景"
          @change="getTableList"
          clearable 
        >
          <el-option
            v-for="item in languageType"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-select
          size="medium"
          v-model="searchForm.type"
          placeholder="请选择分类"
          @change="getTableList"
          clearable 
        >
          <el-option
            v-for="item in articleTypeOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <!-- <el-select
          size="medium"
          v-model="searchForm.flag"
          placeholder="请选择类型"
          @change="getTableList"
          clearable 
        >
          <el-option
            v-for="item in typeOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select> -->
        <el-select
          size="medium"
          v-model="searchForm.examine"
          placeholder="请选择状态"
          @change="getTableList"
          clearable 
        >
          <el-option
            v-for="item in stateOptions"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      </div>
      <div class="searchRight">
        <el-button size="medium" type="primary" icon="el-icon-plus" @click="addFunc('add')">增加</el-button>
      </div>
    </div>
    <el-table border :data="tableData" height="73vh" style="width: 100%">
      <el-table-column prop="name" label="应用版本">
        <template slot-scope="scope">
          <span>{{scope.row.lan=='zh-CN'?'中文版':'英文版'}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="标题"></el-table-column>
      <el-table-column prop="time" label="上传时间"></el-table-column>
      <el-table-column prop="type.name" label="分类"></el-table-column>
      <!-- <el-table-column prop="name" label="类型" width="100px">
        <template slot-scope="scope">
          <el-select
            size="mini"
            v-model="scope.row.flag"
            placeholder="请选择类型"
            @change="changeArticleFlag(scope.row)"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column> -->
      <el-table-column prop="name" label="状态" width="120px">
        <template slot-scope="scope">
          <el-select
            size="small"
            v-model="scope.row.examine"
            placeholder="请选择状态"
            @change="changeArticleExamine(scope.row)"
          >
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <!-- <span>{{scope.row.examine==1?"待审核":scope.row.examine==2?"已审核":scope.rowd.examine==3?"发布":scope.rowd.examine==4?"冻结":""}}</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="way" label="操作" width="160px">
        <template slot-scope="scope">
          <el-button size="small" type="primary" @click="addFunc('edit',scope.row.id)">
            <i class="el-icon-edit" style="margin-right:3px;"></i>修改
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="deleteType(scope.row)"
          >
            <i class="el-icon-delete" style="margin-right:3px;"></i>删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[20, 30, 40]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:20,
        name:'',
        type:'',
        lan: '',
        examine:'',
        isBackend: true
      },
      tableData: [],
      articleTypeOptions:[],
      typeOptions: [
        { name: "普通", value: '0' },
        { name: "推荐", value: '1' },
        { name: "热点", value: '2' }
      ],
      stateOptions: [
        { name: "待审核", value: 1 },
        { name: "已审核", value: 2 },
        { name: "发布", value: 3 },
        { name: "冻结", value: 4 }
      ],
      languageType: [
        { name: "中文", value: 'zh-CN' },
        { name: "英文", value: 'en-US' },
      ],
    };
  },
  created() {
    this.getTableList();
    this.getArticleType();
  },
  methods: {
    addFunc(type,id){
      if(type=='add'){
        this.$router.push({name:'copyAdd'})
      } else {
        this.$router.push({name:'copyAdd',query:{id:id}})
      }
    },
    async getTableList(val) {
      if (val) {
        this.searchForm.page = 1;
      }
      console.log(this.searchForm)
      let res = await this.$http.getArticleList({
        ...this.searchForm
      });
      if (res) {
        this.tableData = res.data.list;
        this.totalNum = res.data.totalSize;
      }
    },
    // 分类
    async getArticleType(val){
       let res = await this.$http.articleTypeList({name:''});
        if (res) {
        this.articleTypeOptions=res.data
        }
    },
    // 修改类型
    async changeArticleFlag(row){
        let res = await this.$http.updateArticleFlag({id:row.id,flag:row.flag});
        if (res) {
          this.$message.success('操作成功！');
          this.getTableList()
        }
    },
    // 修改状态
    async changeArticleExamine(row){
        let res = await this.$http.updateArticleExamine({id:row.id,examine:row.examine});
        if (res) {
          this.$message.success('操作成功！');
          this.getTableList()
        }
    },
    deleteType(row){
        this.$confirm(`确定要删除 ${row.name} 文章吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let res = await this.$http.delArticle({id:row.id});
          if (res) {
            this.$message.success('操作成功！');
            this.getTableList()
          }
        }).catch(() => {
                
        });
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>

<style scoped>
</style>
